import React from "react"
import {
	RateProps,
	TextProps,
} from "components/Shared/Cards/SummaryCard/components"
import { ReactComponent as Demanding } from "assets/images/customer_profiling/seghabits0.svg"
import { ReactComponent as Spontaneous } from "assets/images/customer_profiling/seghabits1.svg"
import { ReactComponent as Optimizer } from "assets/images/customer_profiling/seghabits2.svg"
import { ReactComponent as Flexible } from "assets/images/customer_profiling/seghabits3.svg"
import { COLOR_PALETTE } from "colors"

interface CardsProps {
	title: string
	icon: React.ReactChild
	color: string
	rates: Array<RateProps>
	collapse: {
		rates: Array<RateProps>
		preferences: Array<TextProps>
		description: TextProps
	}
}

const frecuency =
	"phronesis.customerbehavior.application.customerProfiling.habits.frecuency"
const discount =
	"phronesis.customerbehavior.application.customerProfiling.habits.discount"
const varProduct =
	"phronesis.customerbehavior.application.customerProfiling.habits.varProduct"
const levelPrice =
	"phronesis.customerbehavior.application.customerProfiling.habits.levelPrice"
const basketSize =
	"phronesis.customerbehavior.application.customerProfiling.habits.basketSize"
const storesAndFormat =
	"phronesis.customerbehavior.application.customerProfiling.habits.storesAndFormat"
const description =
	"phronesis.customerbehavior.application.customerProfiling.habits.description"

const count: number = 4

const spontaneousColor: string = COLOR_PALETTE.PURPLE_500
const optimizerColor: string = COLOR_PALETTE.CHART_2
const flexibleColor: string = COLOR_PALETTE.YELLOW_600
const demandingColor: string = COLOR_PALETTE.CHART_3

const spontaneousHeaderColor: string = COLOR_PALETTE.PURPLE_100
const optimizerHeaderColor: string = COLOR_PALETTE.HEADER_2
const flexibleHeaderColor: string = COLOR_PALETTE.YELLOW_100
const demandingHeaderColor: string = COLOR_PALETTE.HEADER_3

const spontaneousCard: Array<RateProps> = [
	{
		color: spontaneousColor,
		title: frecuency,
		count,
		value: 4,
	},
	{
		color: spontaneousColor,
		title: discount,
		count,
		value: 3,
	},
	{
		color: spontaneousColor,
		title: varProduct,
		count,
		value: 1,
	},
	{
		color: spontaneousColor,
		title: levelPrice,
		count,
		value: 1,
	},
]

const spontaneousCardCollapse: Array<RateProps> = [
	{
		color: spontaneousColor,
		title: basketSize,
		count,
		value: 1,
	},
]

const optimizerCard: Array<RateProps> = [
	{
		color: optimizerColor,
		title: frecuency,
		count,
		value: 3,
	},
	{
		color: optimizerColor,
		title: discount,
		count,
		value: 1,
	},
	{
		color: optimizerColor,
		title: varProduct,
		count,
		value: 4,
	},
	{
		color: optimizerColor,
		title: levelPrice,
		count,
		value: 2,
	},
]

const optimizerCardCollapse: Array<RateProps> = [
	{
		color: optimizerColor,
		title: basketSize,
		count,
		value: 2,
	},
]

const flexibleCard: Array<RateProps> = [
	{
		color: flexibleColor,
		title: frecuency,
		count,
		value: 2,
	},
	{
		color: flexibleColor,
		title: discount,
		count,
		value: 1,
	},
	{
		color: flexibleColor,
		title: varProduct,
		count,
		value: 4,
	},
	{
		color: flexibleColor,
		title: levelPrice,
		count,
		value: 3,
	},
]

const flexibleCardCollapse: Array<RateProps> = [
	{
		color: flexibleColor,
		title: basketSize,
		count,
		value: 3,
	},
]

const demandingCard: Array<RateProps> = [
	{
		color: demandingColor,
		title: frecuency,
		count,
		value: 1,
	},
	{
		color: demandingColor,
		title: discount,
		count,
		value: 4,
	},
	{
		color: demandingColor,
		title: varProduct,
		count,
		value: 3,
	},
	{
		color: demandingColor,
		title: levelPrice,
		count,
		value: 4,
	},
]

const demandingCardCollapse: Array<RateProps> = [
	{
		color: demandingColor,
		title: basketSize,
		count,
		value: 4,
	},
]

const spontaneous: CardsProps = {
	title:
		"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.spontaneous",
	icon: <Spontaneous style={{ color: spontaneousColor }} />,
	color: spontaneousHeaderColor,
	rates: spontaneousCard,
	collapse: {
		rates: spontaneousCardCollapse,
		preferences: [
			{
				title: storesAndFormat,
				text:
					"phronesis.customerbehavior.application.customerProfiling.habits.stores.spontaneous",
			},
		],
		description: {
			title: description,
			text:
				"phronesis.customerbehavior.application.customerProfiling.habits.description.spontaneous",
		},
	},
}

const optimizer: CardsProps = {
	title:
		"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.optimizer",
	icon: <Optimizer style={{ color: optimizerColor }} />,
	color: optimizerHeaderColor,
	rates: optimizerCard,
	collapse: {
		rates: optimizerCardCollapse,
		preferences: [
			{
				title: storesAndFormat,
				text:
					"phronesis.customerbehavior.application.customerProfiling.habits.stores.optimizer",
			},
		],
		description: {
			title: description,
			text:
				"phronesis.customerbehavior.application.customerProfiling.habits.description.optimizer",
		},
	},
}

const flexible: CardsProps = {
	title:
		"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.flexible",
	icon: <Flexible style={{ color: flexibleColor }} />,
	color: flexibleHeaderColor,
	rates: flexibleCard,
	collapse: {
		rates: flexibleCardCollapse,
		preferences: [
			{
				title: storesAndFormat,
				text:
					"phronesis.customerbehavior.application.customerProfiling.habits.stores.flexible",
			},
		],
		description: {
			title: description,
			text:
				"phronesis.customerbehavior.application.customerProfiling.habits.description.flexible",
		},
	},
}

const demanding: CardsProps = {
	title:
		"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.demanding",
	icon: <Demanding style={{ color: demandingColor }} />,
	color: demandingHeaderColor,
	rates: demandingCard,
	collapse: {
		rates: demandingCardCollapse,
		preferences: [
			{
				title: storesAndFormat,
				text:
					"phronesis.customerbehavior.application.customerProfiling.habits.stores.demanding",
			},
		],
		description: {
			title: description,
			text:
				"phronesis.customerbehavior.application.customerProfiling.habits.description.demanding",
		},
	},
}

export const cards: Array<CardsProps> = [
	spontaneous,
	optimizer,
	flexible,
	demanding,
]
